import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 20 10",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 5.5h2v-1h-2v-3h-15v7h15zM20 7h-2v1.67c0 .73-.6 1.33-1.33 1.33H1.33C.6 10 0 9.4 0 8.66V1.33C0 .6.6 0 1.34 0h15.33C17.4 0 18 .6 18 1.33V3h2z"/>' }
  })
);